// Previzualizarea textelor din „Mesaje automate": aceeași regulă ca pe backend
// (message-templates/render.ts → renderText). Etichetele {nume} se înlocuiesc
// cu valorile date; o etichetă fără valoare dispare, iar textul se curăță ca
// să rămână firesc („Salut, {prenume}!" fără prenume → „Salut!").

const PLACEHOLDER_RE = /\{([a-zA-Z]+)\}/g;

/** Numele etichetelor folosite într-un text, fără dubluri. */
export function placeholdersIn(text) {
   const found = new Set();
   for (const match of String(text ?? "").matchAll(PLACEHOLDER_RE)) {
      found.add(match[1]);
   }
   return [...found];
}

export function renderMessageText(text, vars = {}) {
   const filled = String(text ?? "").replace(PLACEHOLDER_RE, (whole, name) =>
      Object.prototype.hasOwnProperty.call(vars, name)
         ? String(vars[name] ?? "").trim()
         : whole,
   );
   return filled
      .split("\n")
      .map((line) =>
         line
            .replace(/[ \t]*,[ \t]*([!?.,])/g, "$1")
            .replace(/[ \t]{2,}/g, " ")
            .trim(),
      )
      .join("\n")
      .trim();
}

/** Valorile de exemplu ale etichetelor unui text (pentru previzualizare). */
export function exampleVars(placeholders) {
   const vars = {};
   for (const p of placeholders || []) vars[p.name] = p.example;
   return vars;
}
